import React from "react";
import { grid } from "../constants";
import Text from "@gc-npm/components.text";

const Title = ({ title, subTitle, isOpen }) => {
  return (
    <>
      <div className="title-cont" data-cy="Ecosystem Container Text">
        <div className="animation-cont">
          {title && <Text {...title} cyData="Ecosystem Title" />}
          {subTitle && <Text {...subTitle} cyData="Ecosystem SubTitle" />}
        </div>
      </div>
      <style jsx>{`.title-cont {
  overflow: hidden;
}
.title-cont .animation-cont {
  opacity: ${isOpen ? 0 : 1};
  transition: opacity 300ms linear;
}
.title-cont .animation-cont :global(.title) {
  text-align: center;
  padding: 1rem 2rem;
}
.title-cont .animation-cont :global(.sub-title) {
  text-align: center;
  padding: 1rem 0;
}

@media screen and (min-width: ${grid.breakpoint_sm}px) {
  .title-cont .animation-cont :global(.title) {
    padding: 0;
    padding: 0 0;
    text-align: left;
    margin-bottom: 0.5rem;
  }
  .title-cont .animation-cont :global(.sub-title) {
    padding: 0;
    text-align: left;
  }
}`}</style>
    </>
  );
};

export default Title;
